// 整案订单列表
export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '录单人',
		align: 'center',
		dataIndex: 'creatorName',
	},
	{
		title: '所属机构',
		align: 'center',
		dataIndex: 'companyName',
	},
	{
		title: '录单时间',
		align: 'center',
		dataIndex: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '所属险种',
		align: 'center',
		dataIndex: 'insuranceType',
		scopedSlots: { customRender: 'insuranceType' },
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
	},
	// {
	// 	title: '案件状态',
	// 	align: 'center',
	// 	dataIndex: 'caseStatus',
	// 	scopedSlots: { customRender: 'caseStatus' },
	// },
	{
		title: '伤者姓名',
		align: 'center',
		dataIndex: 'injuredName',
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]

// 整案详情伤者任务列表
export const injuryColumns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '录单人',
		align: 'center',
		width: 100,
		dataIndex: 'relationCreatorName',
	},
	{
		title: '录单时间',
		align: 'center',
		width: 120,
		dataIndex: 'relationCreateTime',
		scopedSlots: { customRender: 'timeFormat' },
	},
	{
		title: '完成时间',
		align: 'center',
		width: 120,
		dataIndex: 'relationFinishTime',
		scopedSlots: { customRender: 'timeFormat' },
	},
	{
		title: '任务类型',
		align: 'center',
		width: 120,
		dataIndex: 'relationTaskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '订单类型',
		align: 'center',
		width: 120,
		dataIndex: 'relationOrderType',
		scopedSlots: { customRender: 'orderType' },
	},
	{
		title: '订单号',
		align: 'center',
		width: 240,
		dataIndex: 'relationOrderNo',
		scopedSlots: { customRender: 'orderNo' },
	},
	{
		title: '作业所在地区',
		align: 'center',
		width: 150,
		dataIndex: 'relationTaskArea',
		scopedSlots: { customRender: 'taskArea' },
	},
	{
		title: '任务状态',
		align: 'center',
		width: 120,
		dataIndex: 'relationTaskStatus',
		scopedSlots: { customRender: 'taskStatus' },
	},
	{
		title: '任务处理人',
		align: 'center',
		width: 150,
		dataIndex: 'relationOperatorName',
		scopedSlots: { customRender: 'operator' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		width: 100,
		dataIndex: 'relationType',
		scopedSlots: { customRender: 'action' },
	},
]

// 整案详情新增未决/终止任务的全流程初次探视列表
export const actionColumns = [
	{
		title: '初次订单号',
		align: 'center',
		width: 150,
		dataIndex: 'orderNo',
	},
	{
		title: '录单人',
		align: 'center',
		width: 110,
		dataIndex: 'creatorName',
		scopedSlots: { customRender: 'creator' },
	},
	{
		title: '作业所在地区',
		align: 'center',
		width: 120,
		dataIndex: 'taskArea',
	},
	{
		title: '订单状态',
		align: 'center',
		width: 60,
		dataIndex: 'orderStatusDesc',
	},
]
